import { useSiteSettings } from '../hooks/useContent';
import LegalPage from '../components/LegalPage';
import { DEFAULT_TERMS_HTML } from '../utils/siteSettingsJson';

export default function Terms() {
  const { settings, loading } = useSiteSettings();
  const title = String(settings.terms_page_title || '').trim() || 'Terms & Conditions';
  const html = String(settings.terms_page_html || '').trim() || DEFAULT_TERMS_HTML;
  const publicBase =
    String(settings.site_public_url || '').replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  return (
    <LegalPage
      pageTitle={title}
      contentHtml={html}
      seoPath="/terms"
      brand={settings.site_brand_name || 'Invincible NGO'}
      metaDescription={settings.site_meta_description}
      publicBase={publicBase}
      loading={loading}
    />
  );
}
